export const environment = {
  production: true,
  buildId: '2651907565718241',
  configFile: 'config.json',
};
